export enum Status {
  Inactive = 1,
  Active = 2,
}
